export default __webpack_public_path__ + "static/media/apply_letter.3764a553.svg";